import { render, staticRenderFns } from "./FormDataUri.vue?vue&type=template&id=38f67eb0&scoped=true"
import script from "./FormDataUri.vue?vue&type=script&lang=js"
export * from "./FormDataUri.vue?vue&type=script&lang=js"
import style0 from "./FormDataUri.vue?vue&type=style&index=0&id=38f67eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f67eb0",
  null
  
)

export default component.exports